import { render, staticRenderFns } from "./ControleAcessoView.vue?vue&type=template&id=b8068512&scoped=true&"
import script from "./ControleAcessoView.vue?vue&type=script&lang=js&"
export * from "./ControleAcessoView.vue?vue&type=script&lang=js&"
import style0 from "./ControleAcessoView.vue?vue&type=style&index=0&id=b8068512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8068512",
  null
  
)

export default component.exports